// extracted by mini-css-extract-plugin
module.exports = {"Toggle":"Toggle__Toggle--oy5ZJ","Title":"Toggle__Title--20aX6"};